import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

import './LoginFormHeader.custom.scss';
import './LoginFormHeader.theme.scss';

function LoginFormHeader({ isAnonymousUser, cancel, ipAddress, actionMessage, infoMessage, children }) {
  const handleCancelClick = (e) => {
    if (!cancel) {
      return;
    }
    cancel(e);
  };

  return (
    <>
      <div className="login-form-header__buttons">
        {ipAddress && <div className="login-form-header__buttons_ip">{`Your IP: ${ipAddress}`}</div>}
        {isAnonymousUser && (
          <Button
            buttonConfig={{
              type: 'link',
              size: 'xs',
              e2eName: 'login-cancel',
              iconOnly: true,
              ariaLabel: 'Cancel login',
              className: 'login-form-header__buttons_button',
            }}
            iconConfig={{
              name: 'delete',
              size: 'sm',
            }}
            onClick={handleCancelClick}
          />
        )}
      </div>
      {children}
      <h1 className="e2e-login-header login-form-header__actionMessage u-els-font-size-h2">{actionMessage}</h1>
      <h2 className="login-form-header__infoMessage typography-small">{infoMessage}</h2>
    </>
  );
}

LoginFormHeader.propTypes = {
  isAnonymousUser: PropTypes.bool,
  cancel: PropTypes.func,
  ipAddress: PropTypes.string,
  actionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  infoMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
};

export default LoginFormHeader;
